// extracted by mini-css-extract-plugin
module.exports = {"container":"ProductShare_container__zxmG8","productShareWrapper":"ProductShare_productShareWrapper__ISKOQ","shareImageWrapper":"ProductShare_shareImageWrapper__49Otm"};